import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import TopBar from "@/components/site/TopBar";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Locations from "@/components/site/Locations";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import MobileBar from "@/components/site/MobileBar";
import ChatWidget from "@/components/site/ChatWidget";

const Home = () => (
  <div className="bg-[#f8fafc] text-[#0f172a] antialiased">
    <TopBar />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Gallery />
      <Locations />
      <About />
      <Contact />
    </main>
    <Footer />
    <MobileBar />
    <ChatWidget />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
